<template>
  <div data-component-group="invoice-form" data-component="totals">
    <slot name="beforeForm" />

    <div class="component-body">
      <AmountLabel label="Subtotal" size="lg" :value="subTotal" />
      <AmountLabel label="Tax" size="lg" :value="tax" />
      <AmountLabel label="Total" size="lg" :value="total" />
    </div>
  </div>
</template>

<script>
  import AmountLabel from '../../labels/Amount';
  import { isObj } from '../../../utils';
  // TODO: Translate component

  export default {
    components: {
      AmountLabel,
    },
    props: {
      invoice: {
        type: Object,
        required: true,
      },
    },
    computed: {
      currencyCode() {
        const { invoice } = this;

        return isObj(invoice) &&
          isObj(invoice.cost_center) &&
          isObj(invoice.cost_center.currency)
          ? invoice.cost_center.currency.code
          : '';
      },
      subTotal() {
        return `${this.invoice.subtotal_amount} ${this.currencyCode}`;
      },
      tax() {
        return `${this.invoice.tax_amount} ${this.currencyCode}`;
      },
      total() {
        return `${this.invoice.total_amount} ${this.currencyCode}`;
      },
    },
  };
</script>

<style lang="scss">
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='invoice-form'][data-component='totals'] {
  padding: $spacing-xl;
  background-color: rgb(var(--v-theme-surface));
  border-top: 1px solid map.get($colors, grey, lighten-2);

  > .component-body {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;

    .item-label {
      display: inline-block;
      min-width: 60px;
    }
  }
}
</style>
